export enum PeerReviewerState
{
    Unknown,
    Active,
    Inactive
}